import { render } from "./text-modal-small-component.vue?vue&type=template&id=aa1c2e60"
import script from "./text-modal-small-component.vue?vue&type=script&lang=js"
export * from "./text-modal-small-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__